import styles from './FadeInContainer.module.scss';

function FadeInContainer({ children }) {
  return (
    <>
      <div className={styles.fade_in}>{children}</div>
    </>
  );
}
export default FadeInContainer;
